export const ROLES_REQUEST = "ROLES_REQUEST";
